module.exports = __webpack_public_path__ + "media/src/public/img/manifest-0d3b2c40e85c7c858d439c590dd4ce55.webmanifest";